import { Outlet } from 'react-router-dom';

import { SettingsMenu } from './SettingsMenu';

import style from './SettingsLayout.module.scss'


const SettingsLayout = () => {
  return (
    <div className={style.wrap}>
      <SettingsMenu />
      <main className={style.content}>
        <Outlet />
      </main>
    </div>
  )
}

export { SettingsLayout };